export default "__VITE_ASSET__DV$F$0KP__"